import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
  TransitionChild,
} from "@headlessui/react";
import { platforms } from "./helper";
import { trackPlatformUsed } from "../../components/trackers";
import ProjectIntegrationForm from "./forms/projectIntegrationForm";

const SelectPlatform = ({ open, onClose,project = null,
  setProject = null,
  integrationData = null }) => {
   

  const { t } = useTranslation();
  const [selectedPlatform, setSelectedPlatform] = useState(null);
  const handleSelectPlatform = (platform) => {
    trackPlatformUsed("website", `select_platform_${platform.name.toLowerCase()}`);
    setSelectedPlatform(platform);
  };

  const handleBackToList = () => {
    setSelectedPlatform(null);
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        setSelectedPlatform(null);
        onClose();
      }}
      className="relative z-[999]"
    >
      {/*  Proper backdrop with fixed position and transitions */}
      <DialogBackdrop
        className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />

      {/*  Modal container centered */}
      <div className="fixed inset-0 z-[999] flex items-center justify-center p-4 overflow-y-auto bg-black/50">
        <DialogPanel className="relative w-full max-w-lg transform overflow-hidden rounded-xl bg-white p-6 shadow-xl transition-all">
          {/* Close button */}
          <button
            className="absolute top-3 right-4 text-gray-400 hover:text-gray-600 text-2xl"
            onClick={() => {
              setSelectedPlatform(null);
              onClose();
            }}
          >
            &#10005;
          </button>

          {/* Platform selection list */}
          {!selectedPlatform ? (
            <>
              <DialogTitle className="text-xl font-semibold text-gray-900 mb-4">
                {t("Select a CMS Platform", "Sélectionnez une plateforme CMS")}
              </DialogTitle>

              <div className="flex flex-wrap justify-center gap-6 mt-6">
                {platforms.map((platform) => (
                  <div
                    key={platform.name}
                    onClick={() => handleSelectPlatform(platform)}
                    className="w-32 h-32 bg-white border shadow-lg rounded-lg p-4 flex flex-col items-center justify-center cursor-pointer transform transition-transform hover:scale-105"
                  >
                    <img
                      src={platform.logo}
                      alt={platform.name}
                      className="h-16 object-contain mb-2"
                    />
                    {/* <span className="text-sm font-medium text-gray-800 text-center">
                      {platform.name}
                    </span> */}
                  </div>
                ))}
              </div>
            </>
          ) : (
            <>
              <div className="flex items-center justify-between mb-4">
                <DialogTitle className="text-xl font-semibold text-gray-900">
                  {selectedPlatform.title}
                </DialogTitle>
                
              </div>

              {selectedPlatform?.tuto && (
                <a
                  href={selectedPlatform?.tuto?.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-500 text-sm hover:underline"
                >
                  {selectedPlatform?.tuto?.text}
                </a>
              )}

              <div className="mt-6">
                <ProjectIntegrationForm
  platform_name={selectedPlatform?.name?.toLowerCase()}
  project={project}
  setProject={setProject}
  integrationData={integrationData}
  onCloseDialog={() => {
    setSelectedPlatform(null);
    onClose(); 
  }}
/>

              </div>
            </>
          )}
        </DialogPanel>
      </div>
    </Dialog>
  );
};

export default SelectPlatform;
